import { Tooltip, Link } from '@mui/material';
import { PATH } from '@old/data/core/paths';
import { useAuth } from '@old/hooks/use-auth';
import i18n from '../../../libs/language';
import { NavLink } from 'react-router';
import AdministratorIcon from '@old/assets/svg/main-menu/administrator.svg';
import AdministratorActiveIcon from '@old/assets/svg/main-menu/administrator-active.svg';

export function AdministratorIconComponent() {
  const { isAdmin } = useAuth();

  return isAdmin ? (
    <Tooltip title={i18n.t('app.navbar.administrator')} arrow>
      <Link
        component={NavLink}
        to={PATH.ADMINISTRATOR}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          position: 'relative',
          width: 40,
          height: 40,

          '& .default-icon, & .active-icon': {
            position: 'absolute',
            transition: 'opacity 0.2s ease',
          },

          '& .active-icon': {
            opacity: 0,
          },

          '&:hover .default-icon': {
            opacity: 0,
          },

          '&:hover .active-icon': {
            opacity: 1,
          },

          '&.active .default-icon': {
            opacity: 0,
          },

          '&.active .active-icon': {
            opacity: 1,
          },
        }}
      >
        <img className="default-icon" src={AdministratorIcon} alt="Administrator" width={40} height={40} />

        <img
          className="active-icon"
          src={AdministratorActiveIcon}
          alt="Administrator Active"
          width={40}
          height={40}
        />
      </Link>
    </Tooltip>
  ) : null;
}
